// built-in imports
import React from "react";
import { FormattedMessage } from "react-intl";
import { motion } from "framer-motion";

// internal imports
import { Wrapper } from "./inof-component.styles";
import sectionWrapper from "../../hoc/sction-wrapper.component";
import { fadeIn, zoomIn } from "../../utils/motion/motion.utils";
const Info = () => {
  return (
    <Wrapper>
      <motion.h4 variants={fadeIn("", "", 0.1, 1)}>Mission</motion.h4>
      <motion.h5 variants={fadeIn("", "", 0.1, 1)}>
        <FormattedMessage
          id="mission.info"
          defaultMessage="From concept through to development and delivery, I am highly
        experienced in all aspects of the software development life cycle. I
        assist companies in achieving their objectives and enhancing their image
        by crafting captivating web and android applications."
        />
      </motion.h5>
      <motion.h4 variants={fadeIn("", "", 0.2, 1)}>
        <FormattedMessage id="biography" defaultMessage="Biography" />
      </motion.h4>
      <motion.h5 variants={fadeIn("", "", 0.2, 1)}>
        <FormattedMessage
          id="biography.info"
          defaultMessage="Hi, I'm Shafiq Salehi, a software developer with a passion for creating
        beautiful, functional, and user-centred digital experiences. Meantime, I
        enjoy spending time with family and friends, reading historical books,
        and playing football."
        />
      </motion.h5>
    </Wrapper>
  );
};

export default sectionWrapper(Info);
